import { API_URL } from 'constants/api';
import { PROBLEM_STATUSES_KEY } from 'constants/local-storage';
import { useRevalidate } from 'hooks/useRevalidate';
import {
  FunctionComponent,
  PropsWithChildren,
  createContext,
  useState,
  useEffect,
  useContext,
} from 'react';
import { ApiResponse } from 'types/api';
import { ProblemStatus } from 'types/problem';
import { wrappedFetch } from 'utils/api';

export const ProblemStatusesContext = createContext<ProblemStatus[]>([]);

interface ProblemStatusesProviderProps extends PropsWithChildren {}

export const useProblemStatuses = () => useContext(ProblemStatusesContext);

const ProblemStatusesProvider: FunctionComponent<
  ProblemStatusesProviderProps
> = ({ children }) => {
  const [problemStatues, setProblemStatuses] = useState<ProblemStatus[]>([]);
  const { data, mutate } = useRevalidate<ProblemStatus[]>(
    PROBLEM_STATUSES_KEY,
    604800,
  );

  useEffect(() => {
    if (data) {
      setProblemStatuses(data);
    } else {
      wrappedFetch(`${API_URL}problems/status/list`)
        .then((res: ApiResponse<ProblemStatus[]>) => {
          if ('data' in res) {
            setProblemStatuses(res.data);
            mutate(res.data);
          }
        })
        .catch(() => {});
    }
  }, [data]);

  return (
    <ProblemStatusesContext.Provider value={problemStatues}>
      {children}
    </ProblemStatusesContext.Provider>
  );
};

export default ProblemStatusesProvider;
